<template>
  <div class="product">
    <el-divider content-position="center" class="mb"
      ><h1>企业用便携式VR内容定制</h1></el-divider
    >
    <span
      >针对企业单位，进行定制VR内容开发，采用便携式VR
      体验，降低成本，提高体验舒适度，携带方便， 随拎随展。</span
    >

    <el-row type="flex" justify="center">
      <el-col style="text-align: center" :xs="16" :sm="12" :lg="8">
        <el-image :src="require('@/assets/images/VRtoB1.jpg')"></el-image>
      </el-col>
    </el-row>
    <span
      >产品具有：轻便、舒适、大空间的特性，可以更广泛的应用于教育、社创、安全、展厅、文博等行业。</span
    >
    <el-row type="flex" justify="center">
      <el-col style="text-align: center" :xs="16" :sm="12" :lg="8">
        <el-image :src="require('@/assets/images/VRtoB3.jpg')"></el-image>
        <div class="desc">
          （“一起VR”为九龙坡区领导一行讲解一七 科技“5G
          VR”理念，刘区长对“要一起VR”理念做出重要指示 给予高度评价）
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col style="text-align: center" :xs="16" :sm="12" :lg="8">
        <el-image :src="require('@/assets/images/VRtoB4.jpg')"></el-image>
        <div class="desc">（“一起VR”接受南岸区和京东云领导位临指导）</div>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <router-link tag="div" class="btn" :to="{ name: 'company1' }">
          返回上层
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang='less'>
.mb {
  margin: 40px 0;
}
.el-row {
  margin: 20px 0;
}
.product {
  margin-top: 20px;
  text-align: center;
  // border: 1px solid #000;
}
h1 {
  font-size: 28px;
}
span {
  color: #999;
  font-size: 24px;
  line-height: 36px;
}
.desc {
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
}
.el-col {
  text-align: center;
}
.btn {
  cursor: pointer;
  margin: 10px auto;
  padding: 10px;
  width: 200px;
  border-radius: 10px;
  color: #fff;
  background-image: linear-gradient(to top, #f0ad4e 0%, #eb9316 100%);
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),
    0 1px 1px rgba(0, 0, 0, 0.075);
  &:hover {
    background-image: linear-gradient(20deg, #f0ad4e 0%, #eb9316 100%);
    box-shadow: inset 1px 1px 0 rgba(255, 255, 255, 0.15),
      0 1px 1px rgba(0, 0, 0, 0.075);
  }
}
@media screen and (max-width: 768px) {
  h1 {
    font-size: 18px;
  }
  span {
    font-size: 14px;
  }
}
</style>